import styled, { createGlobalStyle } from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .admin-intakes-page {
    .intakes-area {
      padding: 70px 0;

      .card-box {
        background: #fff;
        border: 1px solid ${colors.border1};
        border-radius: 6px;
        box-shadow: 0 0 25px rgba(0, 0, 0, 0.08);
        padding: 30px;
      }

      .actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
        margin-bottom: 20px;

        .filters {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          input,
          select {
            border: 1px solid ${colors.border3};
            border-radius: 4px;
            padding: 8px 12px;
            font-size: 14px;
          }
        }

        button {
          background: ${colors.red_bg};
          border: none;
          color: #fff;
          text-transform: uppercase;
          font-weight: 600;
          padding: 10px 22px;
          border-radius: 5px;
          &:hover {
            background: ${colors.red_bg2};
          }
        }
      }

      .data-grid {
        table {
          width: 100%;
          border-collapse: collapse;

          th,
          td {
            padding: 12px 14px;
            border: 1px solid ${colors.border3};
            vertical-align: middle;
            font-size: 14px;
          }

          th {
            background: ${colors.red_bg};
            color: #fff;
            text-transform: uppercase;
            font-weight: 600;
          }

          tbody tr:nth-child(odd) {
            background: #fafafa;
          }

          tbody tr:hover {
            background: rgba(0, 0, 0, 0.03);
          }
        }

        .link-button {
          background: transparent;
          border: none;
          color: ${colors.red};
          text-decoration: underline;
          cursor: pointer;
          padding: 0;
          font-size: 14px;
          font-weight: 600;
          &:hover {
            color: ${colors.red2};
          }
        }

        .muted {
          color: ${colors.text3};
        }

        .pagination-controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          gap: 15px;
          flex-wrap: wrap;

          .page-info {
            font-size: 14px;
            color: ${colors.text3};
          }

          .page-actions {
            display: flex;
            align-items: center;
            gap: 10px;

            button {
              padding: 8px 16px;
              border-radius: 4px;
              border: 1px solid ${colors.border3};
              background: ${colors.red_bg};
              color: #fff;
              font-size: 14px;
              font-weight: 600;
              transition: background 0.2s ease;
              &:hover {
                background: ${colors.red_bg2};
              }
              &:disabled {
                opacity: 0.55;
                cursor: not-allowed;
                background: ${colors.border3};
                color: ${colors.text3};
              }
            }

            select {
              border: 1px solid ${colors.border3};
              border-radius: 4px;
              padding: 8px 12px;
              font-size: 14px;
            }
          }
        }
      }
    }

    @media (max-width: 767px) {
      .intakes-area {
        padding: 40px 0;

        .card-box {
          padding: 20px;
        }

        .data-grid {
          overflow-x: auto;
        }
      }
    }
  }
`;

export const IntakeModalStyles = createGlobalStyle`
  .admin-intakes-modal {
    .modal-content {
      border-radius: 10px;
      border: none;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
    }

    .modal-header {
      border-bottom: 1px solid ${colors.border1};
      padding: 20px 24px;

      h5 {
        font-size: 18px;
        font-weight: 600;
        color: ${colors.black1};
      }
    }

    .modal-body {
      padding: 24px;
      background: ${colors.bg2};

      label {
        font-size: 14px;
        font-weight: 600;
        color: ${colors.black1};
      }

      input,
      textarea,
      select {
        font-size: 14px;
      }

      .muted {
        color: ${colors.text3};
        font-size: 13px;
      }
    }

    .modal-footer {
      border-top: 1px solid ${colors.border1};
      padding: 18px 24px;

      button {
        min-width: 120px;
      }
    }
  }
`;
